// Redirection component (Redirector.jsx)
import * as React from 'react';
import {Navigate} from 'react-router-dom';

function Redirector() {
  const redirectToIndex = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const indexId = urlParams.get('in');
    if (indexId) {
      return <Navigate to={`/index/${indexId}`} />;
    } else {
      // Handle invalid or missing indexId
      return <Navigate to="/" />;
    }
  };

  return redirectToIndex();
}

export default Redirector;
